<script lang="ts">
  export interface PageBodyProps {
    class?: HTMLAttributes['class']
  }
</script>

<script setup lang="ts">
  import type { HTMLAttributes } from 'vue'
  import { cn } from '@gat-ship/vue-components'

  const props = defineProps<PageBodyProps>()
</script>

<template>
  <div :class="cn('@container flex w-full flex-col gap-6 py-6', props.class)">
    <slot />
  </div>
</template>
